import { Box, Fade, Stack, Typography } from '@mui/material';
import { CSSProperties, FC } from 'react';

import LockedGradient from '@vp/assets/icons/LockedGradient.svg?react';
import { VpSpinner } from '@vp/common/ui/component/spinner/VpSpinner';
import { VpIcon } from '@vp/common/ui/component/VpIcon';
import { VpOtpCode } from '@vp/common/ui/component/VpOtpCode';
import { useViewModel } from '@vp/common/ui/hook/useViewModel';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';
import { ProfileAccessViewModel } from '@vp/profile/ui/access/ProfileAccessViewModel';

export type ProfileAccessProps = {
  isUnlocked?: boolean;
  onProfileUnlock?: (profile: ProfileModel) => void;
};

export const ProfileAccess: FC<ProfileAccessProps> = props => {
  const viewModel = useViewModel(ProfileAccessViewModel, props);
  const otpStatus = viewModel.status.value === 'loading' ? 'regular' : viewModel.status.value;

  return (
    <Stack gap={3} width={1} maxWidth={{ tablet: '400px' }} alignItems="center">
      <VpIcon Icon={LockedGradient} size={64} glowing />

      <Stack width={1} gap={1.5} alignItems="center">
        <Typography
          color="text.secondary"
          variant="h2"
          textAlign="center"
          sx={{ textShadow: '0px 0px 32px rgba(255, 255, 255, 0.5), 0px 0px 128px rgba(255, 255, 255, 0.5)' }}
        >
          Доступ ограничен
        </Typography>

        <Typography color="text.disabled" variant="body1Regular" textAlign="center">
          Введите 6-значный код, чтобы получить доступ
        </Typography>
      </Stack>

      <Stack width={1} position="relative">
        <VpOtpCode
          status={otpStatus}
          value={viewModel.code.value}
          disabled={viewModel.status.value === 'loading'}
          onChange={viewModel.onCodeChange}
        />

        {viewModel.status.value === 'error' && (
          <Typography sx={{ position: 'absolute', bottom: 0, transform: 'translateY(100%)' }} variant="caption2Regular" color="danger.500">
            {viewModel.errorMessage.value}
          </Typography>
        )}
      </Stack>

      <Fade in={viewModel.status.value === 'loading'} timeout={250} easing="ease-in-out">
        <Box sx={theme => ({ '--vp-text-color': theme.palette.primary[500] }) as CSSProperties}>
          <VpSpinner size="x-large" />
        </Box>
      </Fade>
    </Stack>
  );
};
